import React from "react";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Input from "@material-ui/core/Input";
import SendIcon from "@material-ui/icons/Send";
import { getRoom, getCollection } from "../../constant";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { connect } from "react-redux";
import ChatSingle from "./ChatSingle";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import ProjectFiles from "../projects/ProjectFiles";
import Tooltip from "@material-ui/core/Tooltip";

const styles = (theme) => ({
  mainChatWindow: {
    height: 380,
    overflow: "scroll",
  },
  msgInputMain: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
  },
  msgInput: {
    paddingRight: 50,
    paddingLeft: 60,
    paddingBottom: 15,
    width: "100%",
    background: "#fff",
  },
});

class ChatRoom extends React.Component {
  state = {
    messageText: "",
  };

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  handleKeyUp = (e) => {
    if (e.keyCode == 13) {
      e.preventDefault();
      this.sendMessages();
    }
  };

  sendMessages = () => {
    const { messageText } = this.state;
    const { firestore, profile, room } = this.props;

    if (messageText) {
      firestore
        .add(
          { collection: getRoom(profile, room.id) },
          {
            text: linkify(messageText),
            sanderId: profile.id,
            sanderName: profile.displayName,
            read: false,
            createdAt: Date.now(),
          }
        )
        .then(
          (data) => {
            this.setState({ messageText: "" });
            scrollBtm();

            try {
              let messageId = data.xc.path.segments[5];

              if (messageId) {
                room.users.forEach((user) => {
                  if (user.id != profile.id) {
                    this.addChatNotification(
                      firestore,
                      profile,
                      messageId,
                      user.id,
                      room.id
                    );
                  }
                });
              }
            } catch (e) {}
          },
          (err) => {}
        );
    }
  };

  fileUploaded = (file) => {
    this.setState({ messageText: file });
    this.sendMessages();
  };

  addChatNotification = (firestore, profile, messageId, userId, roomId) => {
    firestore
      .add(
        { collection: getCollection(profile, "chatNotifications") },
        { messageId, userId, roomId }
      )
      .then(
        (data) => {},
        (err) => {}
      );
  };

  render() {
    const { classes, room, messages, profile, firestore } = this.props;
    const { mainChatWindow, msgInputMain, msgInput } = classes;
    const { messageText } = this.state;

    scrollBtm();

    return (
      <React.Fragment>
        <div id="messagesBox" className={mainChatWindow}>
          {messages.map((msg) => {
            return (
              <ChatSingle
                key={"ChatSingle-" + msg.id}
                msg={msg}
                firestore={firestore}
                profile={profile}
                notifications={room.notifications}
              />
            );
          })}
        </div>

        <div className={msgInputMain}>
          <Input
            onKeyUp={this.handleKeyUp}
            onChange={this.handleChange}
            value={messageText}
            // multiline
            id="messageText"
            placeholder="Type a message"
            className={msgInput}
            inputProps={{ "aria-label": "description" }}
          />

          <IconButton
            style={{ position: "absolute", left: 0, bottom: 5 }}
            aria-label="Attach File"
          >
            <AttachFileIcon />
            <ProjectFiles
              newFileUploaded={this.fileUploaded}
              projectId={room.id}
              small
              profile={profile}
              firestore={firestore}
            />
          </IconButton>

          <IconButton
            style={{ position: "absolute", right: 5, bottom: 5 }}
            onClick={this.sendMessages}
          >
            <SendIcon />
          </IconButton>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, props) => {
  const messages =
    state.firestore.ordered[getRoom(state.firebase.profile, props.room.id)] ||
    [];

  messages.sort((a, b) => {
    return a.createdAt - b.createdAt;
  });

  return {
    messages,
    profile: state.firebase.profile,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => {
    if (props.room && props.room.id)
      return [
        {
          collection: getRoom(props.profile, props.room.id),
          // where: ['roomId', '==', props.room.id]
        },
        // {
        //   collection: getCollection(props.profile, 'chatNotifications'),
        //   where: [
        //     ['userId', '==', props.profile.id],
        //     ['roomId', '==', '2397R2436']
        //   ]
        // }
      ];
    else return [];
  })
)(withStyles(styles)(ChatRoom));

function scrollBtm() {
  var objDiv = document.getElementById("messagesBox");
  if (objDiv) {
    objDiv.scrollTop = objDiv.scrollHeight;
    setTimeout(() => {
      objDiv.scrollTop = objDiv.scrollHeight;
    }, 100);
  }
}

function linkify(text) {
  var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
  return text.replace(urlRegex, function (url) {
    return '<a download target="_blank" href="' + url + '">' + url + "</a>";
  });
}
